import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import { RetailerFitGuide_Select } from './RetailerFitGuide_Select.jsx';
import {
  GET_YEARS,
  GET_MAKES,
  GET_MODELS,
  GET_VARIATIONS,
  GET_FITGUIDE_DATA,
  GET_PRODUCTS_BY_MOUNT_DATA,
} from '../Script/RetailerFitGuide_Query.js';
import { Link } from 'react-router-dom';
import Spinner from '/Foundation/Common/code/Views/Foundation/Common/Spinner';
import { IsVariationFactoryInstalledCrossbar } from '../Script/RetailerFitGuide_Utils.js';
import { useAppState } from '../RetailerFitGuide_StateContext.jsx';
import { track_toggleJourney } from '../Script/RetailerFitGuide_Tracking.js';
import { FILTERED_SOLUTION_TYPES } from '../Script/RetailerFitGuide_Constants.js';
import { client } from '/Foundation/SitecoreGraphQL/code/client';

const RetailerFitGuide_CarSelector = forwardRef(
  (
    {
      journey,
      visible,
      queryParameters,
      setResult,
      result,
      summaryText,
      title,
      solution,
      includeGenerationOld,
      allowDiscontinued,
    },
    ref
  ) => {
    const { translations, clearSettings } = useAppState();

    const [selectedYear, setSelectedYear] = useState();
    const [selectedMake, setSelectedMake] = useState();
    const [selectedModel, setSelectedModel] = useState();
    const [selectedVariation, setSelectedVariation] = useState();
    const [years, setYears] = useState();
    const [makes, setMakes] = useState();
    const [models, setModels] = useState();
    const [variations, setVariations] = useState();
    const [lockSelection, setLockSelection] = useState(false);
    const variationSettings = _THULEDATA.retailerFitGuide?.variationSettings;
    const [loadParametersFromQuery, setLoadParametersFromQuery] = useState(queryParameters ? true : false);
    const [loadingYears, setLoadingYears] = useState(false);
    const [loadingMakes, setLoadingMakes] = useState(false);
    const [loadingModels, setLoadingModels] = useState(false);
    const [loadingVariations, setLoadingVariations] = useState(false);
    const [loadingFitGuideData, setLoadingFitGuideData] = useState(false);

    useImperativeHandle(ref, () => ({
      resetSelection: () => {
        setResult(false);
        setLockSelection(false);
        setSelectedVariation(null);
        setSelectedModel(null);
        setSelectedMake(null);
        setSelectedYear(null);
      },
      unlockSelection: () => {
        setLockSelection(false);
        setResult(null);
      },
    }));

    useEffect(() => {
      getYears();
    }, []);

    useEffect(() => {
      if (!selectedYear) return;

      setSelectedMake(null);
      setMakes(null);

      setSelectedModel(null);
      setModels(null);

      setSelectedVariation(null);
      setVariations(null);

      getMakes();
    }, [selectedYear]);

    useEffect(() => {
      if (!selectedYear) return;

      setSelectedModel(null);
      setModels(null);

      setSelectedVariation(null);
      setVariations(null);
      if (selectedMake) {
        getModels();
      }
    }, [selectedMake]);

    useEffect(() => {
      if (!selectedMake) return;
      setSelectedVariation(null);
      setVariations(null);

      if (selectedModel) {
        getVariations();
      }
    }, [selectedModel]);

    useEffect(() => {
      if (!selectedVariation) return;
      if(queryParameters) search(selectedVariation);
    }, [selectedVariation]);

    const search = (variation) => {
      setLockSelection(true);

      if (IsVariationFactoryInstalledCrossbar(variation.variationId)) {
        getCompatibleProductsForFactoryInstalledCrossbars();
      } else {
        getFitGuideData();
      }
    };

    const stepBack = () => {
      if (lockSelection) {
        setLockSelection(false);
        setResult(null);
      } else if (selectedVariation) setSelectedVariation(null);
      else if (selectedModel) setSelectedModel(null);
      else if (selectedMake) setSelectedMake(null);
      else if (selectedYear) setSelectedYear(null);
    };

    //QUERY
    const getYears = async () => {
      setLoadingYears(true);
      const result = await client.query(GET_YEARS, {
        language: _THULEDATA.SitecoreLanguage,
        solutionTypes: FILTERED_SOLUTION_TYPES,
      });
      if (result.data?.retailerFitGuide.getYears) setYears(result.data.retailerFitGuide?.getYears);
      if (loadParametersFromQuery && queryParameters?.year)
        setSelectedYear(result.data.retailerFitGuide?.getYears?.find((x) => x.year === +queryParameters.year));
      setLoadingYears(false);
    };

    const getMakes = async () => {
      setLoadingMakes(true);
      const result = await client.query(GET_MAKES, {
        language: _THULEDATA.SitecoreLanguage,
        year: String(selectedYear?.year),
        solutionTypes: FILTERED_SOLUTION_TYPES,
      });
      setMakes(result.data?.retailerFitGuide?.getMakes);
      if (loadParametersFromQuery && queryParameters?.make && result.data?.retailerFitGuide?.getMakes)
        setSelectedMake(result.data.retailerFitGuide?.getMakes?.find((x) => x.make === queryParameters.make));
      setLoadingMakes(false);
    };

    const getModels = async () => {
      setLoadingModels(true);
      const result = await client.query(GET_MODELS, {
        language: _THULEDATA.SitecoreLanguage,
        year: String(selectedYear?.year),
        make: selectedMake?.make,
        allowDiscontinued: allowDiscontinued,
        solutionTypes: FILTERED_SOLUTION_TYPES,
      });
      if (result.data?.retailerFitGuide.getModels) setModels(result.data.retailerFitGuide?.getModels);
      if (loadParametersFromQuery && queryParameters?.model && result.data?.retailerFitGuide?.getModels)
        setSelectedModel(result.data.retailerFitGuide?.getModels?.find((x) => x.model === queryParameters.model));
      setLoadingModels(false);
    };

    const getVariations = async () => {
      setLoadingVariations(true);
      const result = await client.query(GET_VARIATIONS, {
        language: _THULEDATA.SitecoreLanguage,
        make: selectedMake?.make,
        model: selectedModel?.model,
        modelData: selectedModel?.modelData,
        year: String(selectedYear?.year),
        solutionTypes: FILTERED_SOLUTION_TYPES,
      });
      if (result.data?.retailerFitGuide.getVariations && result.data?.retailerFitGuide.getVariations.length > 0) {
        let variationResult = result.data.retailerFitGuide.getVariations;
        if (variationSettings?.length > 0) {
          variationResult = result.data.retailerFitGuide.getVariations.map((item) => {
            const id = item.bedTypeLovId ? item.bedTypeLovId : item.variationId;
            const variationSetting = variationSettings?.find((x) => {
              return x.Id == id;
            });
            return {
              ...item,
              ImageUrl: variationSetting?.ImageUrl,
              ImageAlt: variationSetting?.ImageAlt,
              displayName: item.bedType ? `${item?.variation} (${item.bedType} ${item.bedLength})` : item?.variation,
              id,
            };
          });
        }

        setVariations(variationResult);

        if (
          loadParametersFromQuery &&
          queryParameters.model === selectedModel.model &&
          queryParameters?.variation &&
          variationResult?.length > 0
        ) {
          const variation = variationResult.find(
            (x) =>
              x.variationId === queryParameters.variation &&
              (!x.bedTypeLovId || x.bedTypeLovId === queryParameters.bedTypeLovId)
          );
          setSelectedVariation(variation);
          setLoadParametersFromQuery(false);
        }
      }
      setLoadingVariations(false);
    };

    const getFitGuideData = async () => {
      setLoadingFitGuideData(true);

      const result = await client.query(GET_FITGUIDE_DATA, {
        language: _THULEDATA.SitecoreLanguage,
        make: selectedMake?.make,
        model: selectedModel?.model,
        modelData: selectedModel?.modelData,
        year: String(selectedYear?.year),
        variationId: selectedVariation?.variationId,
        bedTypeLovId: selectedVariation.bedTypeLovId,
        includeGenerationOld: includeGenerationOld
      });

      const tempCarResult = {
        year: selectedYear.year,
        make: selectedMake.make,
        model: selectedModel.model,
        modelData: selectedModel?.modelData,
        carVariation: selectedVariation.variation,
        carVariationLovId: selectedVariation.variationId,
        solutionId: selectedVariation.solutionId,
        bedTypeLovId: selectedVariation.bedTypeLovId,
      };
      setResult({ ...result.data?.retailerFitGuide?.getFitGuideData, ...tempCarResult });
      setLoadingFitGuideData(false);
    };

    const getCompatibleProductsForFactoryInstalledCrossbars = async () => {
      const result = await client.query(GET_PRODUCTS_BY_MOUNT_DATA, {
        solutionId: selectedVariation?.solutionId,
        language: _THULEDATA.SitecoreLanguage,
      });
      setResult({
        ProductMountData: result.data?.retailerFitGuide?.getProductMountData,
        year: selectedYear.year,
        make: selectedMake.make,
        model: selectedModel.model,
        modelData: selectedModel?.modelData,
        carVariationLovId: selectedVariation.variationId,
        solutionId: selectedVariation.solutionId,
      });
    };
    //END QUERY

    const trackClose = () => {
      if (includeGenerationOld)
        //only track close when searching for new car
        return;
      track_toggleJourney(false, journey);
    };

    return (
      <div
        className={`${visible ? '' : 'd-none'} retailerFitGuide_CarSelector ${lockSelection && 'carSelector_collapsed'}`}
      >
        {(!lockSelection || (result && !result.solutions?.length > 0)) && (
          <div className={`carSelector_menu mb-7 mb-lg-9`}>
            <button onClick={stepBack} className={`${!selectedYear ? 'invisible' : ''} `}>
              <span className="sr-only">{translations.stepBack}</span>
              <i className="le-icon-arrow"></i>
            </button>
            <h1 className="paragraph--lead text-center mb-0">{title}</h1>
            <Link onClick={clearSettings} to={'/'}>
              <i className="le-icon-x"></i>
              <span className="sr-only">{translations.close}</span>
            </Link>
          </div>
        )}
        <RetailerFitGuide_Select
          loading={loadingYears}
          dropDownValue={selectedYear}
          setDropDownValue={setSelectedYear}
          name={translations.year}
          options={years}
          optionPropertyName="year"
          optionPropertyValue="year"
        />
        <RetailerFitGuide_Select
          loading={loadingMakes}
          dropDownValue={selectedMake}
          setDropDownValue={setSelectedMake}
          name={translations.make}
          options={makes}
          optionPropertyName={'brand'}
          optionPropertyValue={'make'}
        />
        <RetailerFitGuide_Select
          loading={loadingModels}
          dropDownValue={selectedModel}
          setDropDownValue={setSelectedModel}
          name={translations.model}
          options={models}
          optionPropertyName="model"
          optionPropertyValue={'model'}
        />

        <RetailerFitGuide_Select
          loading={loadingVariations}
          dropDownValue={selectedVariation}
          setDropDownValue={setSelectedVariation}
          name={translations.roofType}
          options={variations}
          optionPropertyName="displayName"
          optionPropertyValue={'id'}
        />

        {lockSelection && (
          <button onClick={stepBack} className="btn_selectionSummary">
            <div className="selectionSummary_wrapper">
              <div className="text-color--gray80">{summaryText}</div>
              <div className="selectionSummary_content heading6 text-color--pitchBlack">
                <div>
                  {selectedYear?.year} {selectedMake?.brand} {selectedModel?.model} {selectedVariation?.variation}
                </div>
                <div>{solution?.dataProductWebtitle1}</div>
              </div>
            </div>
            <i className="le-icon-check-circle"></i>
          </button>
        )}
        {loadingFitGuideData && (
          <div className="mt-4">
            {translations.loading}...
            <Spinner />
          </div>
        )}

        {!lockSelection && (
          <button
            disabled={!selectedVariation}
            onClick={() => {
              search(selectedVariation);
              trackClose();
            }}
            className="btn thule-btn-default w-100 my-9"
          >
            {translations.okContinue}
          </button>
        )}
      </div>
    );
  }
);

export default RetailerFitGuide_CarSelector;
